import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";
/**
 *
 * @param {any} item object containing  room search item
 */
function FoodDetail({ item }) {
    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Date & Time</strong>
                            </td>
                            <td>{cleanDate(item.datetime)}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Meal</strong>
                            </td>
                            <td>{item.meal}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Food Offered</strong>
                            </td>
                            <td>{item.foodOffered}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Amount Taken</strong>
                            </td>
                            <td>{item.amountTaken}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Preference/Cultural Needs</strong>
                            </td>
                            <td>{item.preference}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Staff</strong>
                            </td>
                            <td>
                                <StaffProfileCard item={item.author} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default FoodDetail;
